<template>
	<div id="gycj">
		<VAccount></VAccount>
		<div style="height: 116px;"></div>
		<VBanner></VBanner>
		<!--主体内容开始-->
	<div class="content_box1">
		<div class="content_box2">
			<!--左侧菜单-->
			<div class="menu_box">
				<p class="menu_box_title">新闻中心<span>News</span></p>
				<ul class="menu_box1">
		          <li><a href="/xwzxhome">公司新闻</a></li>
		          <li><a href="/hdjy">活动剪影</a></li>
		          <li class="swbk"><a href="/xgbd">相关报道</a></li>
		       </ul>
			</div>
			<!--右侧主体-->
		<div class="content_boxL">
		       <div class="content_boxL_nav">
		         <p class="content_boxL_nav_title">相关报道</p>
		         <div class="content_boxL_nav_R"><a href="/">首页 &gt;</a> <a href="/xwzx">新闻中心 &gt;</a><a href="/xgbd"> 相关报道</a></div>                          
		       </div>
		       <div class="content_boxL_text">
				<ul class="content_boxL_list">
		            <li v-for="item in datalist[0].dlist">
					<router-link v-bind="{to:'/content/'+item.articleID+'?'+'Mbx1=区市简讯&Mlink=qsjx'}" :title="item.title"  target="_blank" class="content_boxL_list_info">
					{{getShortTitle(item.title)}}
		            <span class="yewu_date">{{item.updateTime|datefmt('YYYY-MM-DD')}}</span>
		           </router-link>
		            </li>
				</ul>
		        <div id="fenye">
		          <el-pagination
		          	background
		            @size-change="handleSizeChange"
		            @current-change="handleCurrentChange"
		            :current-page="pageStatus.currentPage"
		            :page-sizes="[15,20,25]"
		            :page-size="pageStatus.perPage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="pageStatus.totalRec"
		            class="fenye">
		          </el-pagination>
		        </div>
		       </div>
		<div class="clear"></div>
		</div>
		</div>
	</div>
	<VFooter></VFooter>
	</div>
</template>

<script>
import web from "@/assets/js/web.js"
import VAccount from '../subcomponents/account'
import VBanner from '../subcomponents/banner'
import VFooter from '../subcomponents/footer'
export default{
	components:{VAccount,VBanner,VFooter},
	data(){
		return{
		 Mbx1:'区市简讯',
		 Mbx2:'列表详情',
		 show:true,
		 picUrl: web.picPath,
		pageStatus: {
          currentPage: 1,
          perPage: 15,
          totalRec: 0
       },
        datalist:[
          {path:'/xgbd', cfg:{params:{bg:0, count:15}}, dlist:[]},       // 1. 教研动态列表
        ],
		}
	},
	created(){
    this.getCnt(0);  // 获取文章列表的总条数，赋值到 pageStatus.totalRec
    this.getData(0);	
	},
	methods:{
      isNew(index) {
      	let articleDate = this.datalist[0].dlist[index].updateTime.substr(0,10);
      	return articleDate==thisDate;
      },
    // 获取文章总数
    getCnt(nIndex) {
      web.api.get(this.datalist[nIndex].path+ '/count')
        .then(res=>{
          if (res.status) this.pageStatus.totalRec= res.data[0].count;
          else console.log('出错信息:' + res.message)
        })
        .catch(error=>{console.log(error)});
    },
      getData(nIndex) {
        web.api.get(this.datalist[nIndex].path, this.datalist[nIndex].cfg)
          .then(res=>{
            if(res.status) {
              this.datalist[nIndex].dlist= res.data;
              for(let i=0; i<this.datalist[nIndex].dlist.length; i++)
                this.datalist[nIndex].dlist[i].picUrl= this.picUrl+ this.datalist[nIndex].dlist[i].picUrl;
            }
            else console.log('出错信息:' + res.message);
          })
          .catch(error=>{console.log(error)});
      },
	getShortTitle(cTitleString, ndataMaxLen) {
	    if(cTitleString.length>ndataMaxLen) {
	      return cTitleString.substr(0,ndataMaxLen)+'...';
	    }
	    else return cTitleString;
	},
      // 分页操作
      handleSizeChange(val) {
        this.pageStatus.perPage= val;
        this.datalist[0].cfg.params.bg= (this.pageStatus.currentPage-1)*val;
        this.datalist[0].cfg.params.count= val;
        this.getData(0);
      },
      handleCurrentChange(val) {
        this.pageStatus.currentPage= val;
        this.datalist[0].cfg.params.bg= (val-1)*this.pageStatus.perPage;
        this.getData(0);
        scrollTo(0,0);
        console.log(val);
      }
	},
}
</script>

<style scoped>
.content_box1 {
    width: 100%;
    position: relative;
    top:-40px;
    z-index: 595;
    left: 0;
}
.content_box2 {
    width: 1200px;
    overflow: hidden;
    margin: 0 auto;
    /*box-shadow: 0 0 6px #CCC;
	border: 1px solid white;*/
}
.menu_box {
    width: 207px;
    float: left;
}
.menu_box_title {
    width: 207px;
    height: 83px;
    color: white;
    font-size: 24px;
    text-align: center;
    padding-top: 20px;
    background:#419AD6;
}
.menu_box1 {
    width: 207px;
}
.menu_box1 li {
    width: 207px;
    height: 46px;
    font-size: 16px;
    margin: 2px 0;
    text-align: center;
    line-height: 46px;
}
.menu_box1 li a {
    color: #656565;
    display: block;
    background: #cacaca;
    width: 207px;
    height: 46px;
}
.menu_box_title span {
    display: block;
    font-size: 20px;
    color: #fff;
}
/*右侧*/
.content_boxL {
    width: 978px;
    float: right;
    overflow: hidden;
}
.content_boxL_nav {
    width: 978px;
    height: 56px;
    line-height: 56px;
    margin-top: 47px;
    overflow: hidden;
    border-bottom: 1px solid #cacaca;
}
.content_boxL_nav_title {
    float: left;
    font-size: 18px;
    color: #363636;
}
.content_boxL_nav_R {
    float: right;
}
.content_boxL_nav_R a {
    color: #363636;
}
.content_boxL_text {
    width: 945px;
    margin: 0 auto 80px;
}
.content_boxL_text p {
    text-indent: 2em;
    font: 14px/24px "微软雅黑";
    color: #666666;
    margin: 30px 0;
}
.clear {
    clear: both;
}
.menu_box1 li a:hover {
    background:#419AD6;
    color: white;
}
.content_boxL_list {
    width: 978px;
    margin: 30px auto;
    overflow: hidden;
}
.content_boxL_list li {
    border-bottom: 1px dashed #d1d1d1;
    line-height: 45px;
    overflow: hidden;
    width: 958px;
}
.content_boxL_list_info {
    padding-left: 30px;
    color: #333;
    width: 948px;
    font-size: 16px;
    background: url(../../../static/主页素材图/化学.png) no-repeat left center;
}
.yewu_date {
    float: right;
}
#fenye{
	width:660px;
	margin:0 auto;
	margin-top:10px;
	padding-bottom: 10px;
}
.swbk>a{
    background-color:#419AD6 !important;
    color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/xwzx/xgbd.vue